import React from 'react';
import DeliveryMethodStepInfoCard from '../../../components/DeliveryMethodStepInfoCard';
import { DeliveryMethodsStepInfoProps } from './types';
import styles from '../DeliveryMethodsStep/DeliveryMethodsStep.module.scss';

const DeliveryMethodsStepInfo = ({
  shippingMethodsWithProducts = [],
  slaMessage = [{}],
}: DeliveryMethodsStepInfoProps) => (
  <div className={styles['deliver-methods-container']}>
    {shippingMethodsWithProducts.map((shippingMethod) => {
      const currSku = shippingMethod?.products[0].variant.sku;
      const currSlaMessage = slaMessage.filter((sla) => sla.sku === currSku)[0];
      return (
        <DeliveryMethodStepInfoCard
          key={shippingMethod?.key}
          shippingMethod={shippingMethod}
          slaMessage={currSlaMessage}
        />
      );
    })}
  </div>
);

export default DeliveryMethodsStepInfo;
